import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-paginator-custom',
  templateUrl: './paginator-custom.component.html',
  styleUrls: ['./paginator-custom.component.sass'],
})
export class PaginatorCustomComponent implements OnInit {
  @Input() length: number;
  @Input() pageSize: number;
  @Input() pageSizeOptions: number[];
  @Output() $onChangePage = new EventEmitter();
  pageEvent: PageEvent;

  constructor() {}

  ngOnInit() {}

  getDataPaginator($event) {
    this.$onChangePage.emit($event);
  }
}
